export const SET_TOKEN = 'SET_TOKEN';
export const TOKEN_RECEIVED = 'TOKEN_RECEIVED';
export const READY = 'READY';
export const RETURN_TO = 'returnto';
export const AUTH_ROUTE = 'identity-auth';
export const GHOST = 'ghost';
export const AUTHORIZATION_CODE = 'authorizationcode';
export const TTL = 'ttl';
